import React, { useRef, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { ReactToPrint, useReactToPrint } from "react-to-print";
import { mdiWrench, mdiClipboardTextOutline, mdiMicrosoftExcel, mdiMicrosoftWord } from "@mdi/js";
import Icon from "@mdi/react";
import moment from "moment";
import configs from "constants/configs";
import InDS from "Resources/ImagesNew/print-alt-5-white.png";
//import LayoutNew from "common/LayoutPrint";
import { getUserLogin, getBranch, getUrl, getDomain } from "utils/utils";
import "Resources/Css/cssPrint.css";
import DatHangApi from "service/DatHang/DatHangApi";
import LayoutNew from "common/LayoutNew";

var numeral = require("numeral");
class ComponentToPrint extends React.Component {
    render() {
        const HrLine = ({ color }) => (
            <hr
                style={{
                    color: color,
                    backgroundColor: color,
                    height: 1,
                    margin: 2,
                }}
            />
        );
        return (
            <div
                style={{
                    padding: "0px",
                    margin: "0px",
                    backgroundColor: "#ffffff",
                    fontSize: "14px",
                    fontFamily: "tahoma",
                    marginBottom: "50px",
                    height: "fit-content", //fix lỗi giãn dòng khi in
                }}
                id="htmlPrint"
                className="noborder-new"
            >
                <div dangerouslySetInnerHTML={{ __html: this.props.DataSend }} />
            </div>
        );
    }
}

export const RpDonHang = (props) => {
    const dispatch = useDispatch();
    var html = "";
    const [dataPrint, setdataPrint] = useState(html);
    const [isStartProcess, setIsStartProcess] = useState(false);
    const [MauIn, setDataMauIn] = useState("");
    const [OrderCode, setOrderCode] = useState("");
    const [StKeyCkCongThuc, setStKeyCkCongThuc] = useState(false);
    const [StKeyPhieuLenhCat, setStKeyPhieuLenhCat] = useState(false);
    const [ConfigCkCongThuc, setConfigCkCongThuc] = useState(false);
    const [dsMauHoaDon, setdsMauHoaDon] = useState([]);
    const [StKeyChonNhieuMauHoaDon, setStKeyChonNhieuMauHoaDon] = useState(false);
    //sửa
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let OrderID = params.get("OrderID");
    useEffect(() => {
        setIsStartProcess(true);
        DatHangApi.PrintChiTietDonHang(OrderID, "", false).then(
            (response) => {
                if (response.status == 200) {
                    setdataPrint(response.data.htmpPrint);
                    setOrderCode(response.data.OrderCode);
                    setDataMauIn(response.data.MauIn);
                    setStKeyCkCongThuc(response.data.StKeyCkCongThuc);
                    setStKeyPhieuLenhCat(response.data.StKeyPhieuLenhCat);
                    setdsMauHoaDon(response.data.dsMauHoaDon);
                    setStKeyChonNhieuMauHoaDon(response.data.StKeyChonNhieuMauHoaDon);
                }
                setIsStartProcess(false);
            }
        );

    }, []);
    const componentRef = useRef();
    const XuatExcel = () => {
        var uri =
            "data:application/vnd.ms-excel," +
            encodeURIComponent(document.getElementById("htmlPrint").outerHTML);
        var downloadLink = document.createElement("a");
        downloadLink.href = uri;
        downloadLink.download =
            OrderCode + moment().format("YYYYMMDDHHmm") + ".xls";
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
    };
    const XuatWord = () => {
        var uri =
            "data:application/vnd.ms-word," +
            encodeURIComponent(document.getElementById("htmlPrint").outerHTML);
        var downloadLink = document.createElement("a");
        downloadLink.href = uri;
        downloadLink.download =
            OrderCode + moment().format("YYYYMMDDHHmm") + ".doc";
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
    };
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

    const PhieuGiaoNhan = () => {
        window.location.href = "/PrintsFile/PhieuGiaoNhan1?OrderID=" + OrderID;
    };

    const onChangeText = (e) => updateStateThongTin(e);
    const updateStateThongTin = (e) => {
        const value = e.target.value;
        DatHangApi.PrintChiTietDonHang(OrderID, value, ConfigCkCongThuc).then(
            (response) => {
                if (response.status == 200) {
                    setdataPrint(response.data.htmpPrint);
                }
            }
        );
        setDataMauIn(value);
    };
    const onChangeCheck = (e) => updateStateCkCongThuc(e);
    const updateStateCkCongThuc = (e) => {
        const value = e.target.checked;
        DatHangApi.PrintChiTietDonHang(OrderID, MauIn, value).then(
            (response) => {
                if (response.status == 200) {
                    setdataPrint(response.data.htmpPrint);
                }
            }
        );
        setConfigCkCongThuc(value);
    };
    return (
        <LayoutNew isPrint={true} isProgress={isStartProcess}>
            <div
                style={{
                    padding: "15px 10px",
                    margin: "5px",
                    backgroundColor: "#ffffff",
                    fontSize: "14px",
                    fontFamily: "tahoma",
                    marginBottom: "50px",
                }}
            >
                <ComponentToPrint
                    ref={componentRef}
                    DataSend={dataPrint}
                />
            </div>
            <div
                class="fixed"
                style={{ width: "100%", left: "0px", paddingRight: "30px" }}
            >
                <div style={{ width: "100%", clear: "both" }}>
                    <div style={{ marginTop: "25px", float: "right", display: "flex" }}>
                        <a
                            class="button-Add-NoIcon bg-blue-main"
                            href=""
                            onClick={XuatWord}
                        >
                            <Icon
                                path={mdiMicrosoftWord}
                                title="In"
                                size={1.4}
                                color="white"
                            />
                            &nbsp; Lưu File Word{" "}
                        </a>{" "}
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <a
                            class="button-Add-NoIcon bg-blue-main"
                            href=""
                            onClick={XuatExcel}
                        >
                            <Icon
                                path={mdiMicrosoftExcel}
                                title="In"
                                size={1.4}
                                color="white"
                            />
                            &nbsp; Lưu File Excel{" "}
                        </a>{" "}
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <button class="button-Icon-text bg-blue-main" onClick={handlePrint}>
                            <img src={InDS} title="In" alt="" />
                            &nbsp; In Hoá Đơn
                        </button>

                    </div>
                </div>
            </div>
        </LayoutNew >
    );
};
